import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import Dropzone from 'react-dropzone';

import { history } from '../../../store';

import isLoggedIn, {isGM, isSA, isIos, isMobileDevice, isWatchUser} from '../../../utils/auth';
import {
  formatDiamondTitle, 
  formatDiamondSku, 
  formatCarat, 
  formatRatio, 
  formatShape, 
  formatPrice, 
  formatCost, 
  formatCut, 
  formatColor, 
  formatClarity, 
  formatSymmetry, 
  formatPolish, 
  formatLocation, 
  getLocationId, 
  formatMeasurements, 
  formatTable, 
  formatDepth,
  getWatchThumbnailImage,
  getUrlId, 
} from '../../../utils/formatting';

import * as holdConst from '../../../constants/hold';
import * as api from '../../../constants/api';

import {VideoPlayerContainer} from './VideoPlayer';
import RhinoLoading from '../common/RhinoLoading';
import RhinoModal from '../../common/modal/RhinoModal';
import RhinoConfirm from '../../common/confirm/RhinoConfirm';

import * as authActionCreators from '../../../actions/auth';
import * as watchActionCreators from '../../../actions/watches';
import * as leadsActionCreators from '../../../actions/leads';
import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, authActionCreators, watchActionCreators, leadsActionCreators, messagesActionCreators, usersActionCreators);

class SingleWatch extends React.Component {
  

  constructor(props) {
    super(props);

    this.watchSku = getUrlId();

    this.state = {

      watchSku: this.watchSku,
      watch: null,
      currentView: 0,

      transferModalOpen: false,
      transferMessage: '',
      transferName: '',
      transferApptDate: '',
      transferApptTime: '',
      transferBudget: '',

      transferApptDateError: '',

      shareModalOpen: false,

      requestSent: false,

      watchNotFound: false,

      editOpen: false,
      
      imgDrag: false,
      imgPending: false,

      imageDeleteOpen: false,
    }

    if(this.state.watchSku === null) {
      this.userNav('');
    }
  }

  componentDidMount() {
    // Load watch data;
    if(this.state.watch === null) {

      this.props.fetchSingleWatch(this.watchSku)
      .then((respData) => {
        this.setState({ 
          watch: respData.success,
          currentView: respData.success.img1 ? 1 : 0,
        });
      })
      .catch((errorResp) => {
        console.error(errorResp);
        this.setState({
          watchNotFound: true,
        })
      });
    }
  }

  async refreshWatch() {
    const watchResp = await this.props.fetchSingleWatch(this.watchSku)
      .catch((errorResp) => {
        console.error(errorResp);
        this.setState({
          watchNotFound: true,
          watch: null,
          currentView: 0,
        })
      });

    if(!watchResp || !watchResp.success) { return null; }
    
    this.setState({ 
      watch: watchResp.success,
      currentView: watchResp.success.img1 ? 1 : 0,
    });
  }

  userNav(page) {
    history.push('/' + page);
  }

  getDefaultImage() {
    return '/img/watches/watch_icon.svg';
  }

  renderDisplaySection() {

    if(this.state.currentView > 0 && this.state.watch[`img${this.state.currentView}`]) {

      const imgUrl = 'https://watchimg.diamondsdirect.com/';
      const imgFilename = this.state.watch[`img${this.state.currentView}`];

      return (<div className={'displayImage'}>
        <img src={imgUrl + imgFilename} />
      </div>);
    } else {
      return (<div className='displayDefault'>
        <img src={this.getDefaultImage()} />
      </div>);
    }
    return null;
  }

  setDisplayView(displayType) {
    this.setState({ currentView: displayType });
  }

  getCost(diamond) {
    if(!isLoggedIn() || diamond.cost === null || diamond.cost === 0) {
      return '';
    } else {
      if(this.props.auth.hideData) {
        return '';
      } else {
        return '(' + formatCost(diamond) + ')';
      }
    }
  }

  validateTransfer() {
    if(!this.state.transferApptDate) {
      this.setState({
        transferApptDateError: 'Please enter an appointment date',
      });
      return false;
    }
    return true;
  }

  transferWatch() {
    // Transfer watch will exist in future version
  }

  queueShare(watch) {
    // this.props.usersAddToShareQueue([watch], window.location.pathname);
    // this.userNav('customer-profile');
  }

  shouldDisplayZoom() {
    return (this.state.currentView == 'VIDEO' || this.state.currentView == 'IMAGE') && !isMobileDevice() && isLoggedIn();
  }

  changeTransferName(evt) {
    this.setState({ transferName: evt.target.value });
  }

  changeTransferApptDate(evt) {
    this.setState({ transferApptDate: evt.target.value });
  }

  changeTransferApptTime(evt) {
    this.setState({ transferApptTime: evt.target.value });
  }

  changeTransferBudget(evt) {
    this.setState({ transferBudget: evt.target.value });
  }

  changeTransferMessage(evt) {
    this.setState({ transferMessage: evt.target.value });
  }

  openTransferModal() {
    this.setState({ 
      transferModalOpen: true, 
      transferApptDateError: '', 
    });
  }

  closeTransferModal() {
    this.setState({ transferModalOpen: false });
  }

  composeTransferMessage() {
    let baseMessage = '';
    if(this.state.transferName !== '') {
      baseMessage = baseMessage + 'Customer name: ' + this.state.transferName + '\n';
    }
    if(this.state.transferApptDate !== '') {
      baseMessage = baseMessage + 'Appointment Date: ' + this.state.transferApptDate + '\n';
    }
    if(this.state.transferApptTime !== '') {
      baseMessage = baseMessage + 'Appointment Time: ' + this.state.transferApptTime + '\n';
    }
    if(this.state.transferBudget !== '') {
      baseMessage = baseMessage + 'Budget: ' + this.state.transferBudget + '\n';
    }
    if(this.state.transferMessage !== '') {
      baseMessage = baseMessage + 'Message: ' + this.state.transferMessage;
    }
    return baseMessage;
  }

  openShareWatch() {
    this.props.leadsOpenShareDirectDropdown([this.state.watch], 'WATCH');
  }

  openShareInternal() {
    // this.props.messagesOpenNewDiamondDropdown([this.state.watch]);
    // this.setState({ shareModalOpen: false });
  }

  openShareExternal() {
    // this.props.leadsOpenAddDropdown([this.state.watch]);
    // this.setState({ shareModalOpen: false });
  }

  closeShareModal() {
    this.setState({ shareModalOpen: false });
  }

  addIndividualDiamondToCard() {

    // if(this.props.users.customerCard === null) {
    //   return;
    // }

    // let addData = {
    //   card_id: this.props.users.customerCard.id,
    //   watches: [ this.state.watch.sku ],
    // }

    // this.props.leadsAddDiamonds(addData)
    // .then((respData) => {
    //   // Do nothing
    // })
    // // .catch((errorResp) => {
    // //   // console.error(errorResp);
    // // });
  }

  backButtonNav() {
    window.history.back();
  }

  toggleEditOpen() {
    this.setState({ editOpen: !this.state.editOpen });
  }

  getImgCount() {
    if(this.state.watch.img5) {
      return 5;
    } else if(this.state.watch.img4) {
      return 4;
    } else if(this.state.watch.img3) {
      return 3;
    } else if(this.state.watch.img2) {
      return 2;
    } else if(this.state.watch.img1) {
      return 1;
    }
    return 0;
  }

  getImgArray() {
    const imgArray = [];

    if(this.state.watch.img1) {
      imgArray.push(this.state.watch.img1 || null);
    } 
    if(this.state.watch.img2) {
      imgArray.push(this.state.watch.img2 || null);
    } 
    if(this.state.watch.img3) {
      imgArray.push(this.state.watch.img3 || null);
    } 
    if(this.state.watch.img4) {
      imgArray.push(this.state.watch.img4 || null);
    } 
    if(this.state.watch.img5) {
      imgArray.push(this.state.watch.img5 || null);
    }
    return imgArray;
  }

  async onDropImage(files) {

    this.setState({ 
      imgPending: true,
      imgDrag: true,
    });

    const uploadResp = await this.props.watchUploadMedia(this.state.watch.sku, files[0])
      .catch((errResp) => {
        console.error(errResp);
        this.setState({ 
          imgPending: false,
          imgDrag: false,
        });
      });

    if(!uploadResp || !uploadResp.key) {
      return null;
    }

    const updateData = {
      sku: this.state.watch.sku,
      idx: this.getImgCount() + 1,
      s3_key: uploadResp.key,
    };

    await this.props.watchUpdateMedia(updateData)
      .catch((errResp) => {
        this.setState({ 
          imgPending: false,
          imgDrag: false,
        });
      });

    this.refreshWatch();

    this.setState({ 
      imgPending: false,
      imgDrag: false,
    });
  }

  dragEnterInput() {
    this.setState({ imgDrag: true });
  }
  
  dragLeaveInput() {
    this.setState({ imgDrag: false });
  }

  async removeImg() {
    
    const deleteData = {
      sku: this.state.watch.sku,
      idx: this.getImgCount(),
    };

    await this.props.watchDeleteMedia(deleteData)
      .catch((errResp) => {
        this.setState({ 
          imgPending: false,
          imgDrag: false,
        });
      });

    this.refreshWatch();

    this.setState({ imageDeleteOpen: false });
  }

  imageDeleteConfirm() {
    this.setState({ imageDeleteOpen: !this.state.imageDeleteOpen });
  }

  render() {

    const base_url = api.FRONTEND_URL;
    const imgUrl = 'https://watchimg.diamondsdirect.com/';

    return <div className='SingleWatch'>
      {!this.state.watch ?
        <div>
          {this.state.watchNotFound ?
            <div className='diamondNotFound'>
              <div className='notFoundTitle'>Timepiece Not Found</div>
              <div className='notFoundSubtitle'>This timepiece is not currently available or not found</div>
              <div className='backButtonWrapper'>
                <div className={'backButton actionButton'} onClick={() => this.userNav('watches')}>Back to Search</div>
              </div>
            </div> :
            <div className='diamondLoadingWrapper'>
              <RhinoLoading message='Loading timepiece' />
            </div>
          }
        </div> :
        <div>
          <div className={isLoggedIn() ? 'singleDiamondHeader loggedInHeader' : 'singleDiamondHeader'}>Timepiece Profile</div>
          <div className='displaySection'>
            <div className='displayWrapper'>{this.renderDisplaySection()}</div>
            <div className='displayControlsWrapper'>
              {this.state.watch.img1 ?
                <div className={'controlVideo controlElement'} onClick={() => this.setDisplayView(1)}>
                  <img src={imgUrl + this.state.watch.img1} />
                </div> :
                null
              }
              {this.state.watch.img2 ?
                <div className={'controlVideo controlElement'} onClick={() => this.setDisplayView(2)}>
                  <img src={imgUrl + this.state.watch.img2} />
                </div> :
                null
              }
              {this.state.watch.img3 ?
                <div className={'controlVideo controlElement'} onClick={() => this.setDisplayView(3)}>
                  <img src={imgUrl + this.state.watch.img3} />
                </div> :
                null
              }
              {this.state.watch.img4 ?
                <div className={'controlVideo controlElement'} onClick={() => this.setDisplayView(4)}>
                  <img src={imgUrl + this.state.watch.img4} />
                </div> :
                null
              }
              {this.state.watch.img5 ?
                <div className={'controlVideo controlElement'} onClick={() => this.setDisplayView(5)}>
                  <img src={imgUrl + this.state.watch.img5} />
                </div> :
                null
              }
            </div>
          </div>
          <div className='infoSection'>
            {isLoggedIn() ?
              <div className='shareIconWrapper' onClick={this.openShareWatch.bind(this)}>
                <div className='shareImgWrapper'>
                  <img src='/img/singlediamond/share.svg' />
                </div>
                <div className='shareLabelWrapper'>share</div>
              </div> :
              null
            }
            <div className={'diamondTitle'}>{this.state.watch.description}</div>
            <div className='diamondSku'>{this.state.watch.sku}</div>
            <div className='diamondMeasurements'>{this.state.watch.group}</div>
            {this.state.watch.is_available === false ? 
              <div className='diamondOutOfStock'>This timepiece is no longer available</div> :
              null
            }
            {isWatchUser() ?
              <div className='editImagesWrapper'>
                <div className='editImageLabel'>
                  <div className='labelWrapper' onClick={this.toggleEditOpen.bind(this)}>Edit Images</div>
                </div>
                <div className={`editImageDrawer ${this.state.editOpen ? 'open' : ''}`}>
                  <div className='drawerLiner'>

                    {this.getImgArray().map((img, i) => {
                      return <div key={i} className='imageBlock'>
                        <div className='imgWrapper'>
                          <div className='imgLiner'><img src={imgUrl + this.state.watch[`img${i + 1}`]} /></div>
                        </div>
                        {this.getImgCount() === i + 1 ?
                          <div className='controlWrapper'>
                            <div className='controlLiner' onClick={() => this.imageDeleteConfirm(this)}>Remove</div>
                          </div> :
                          null
                        }
                      </div>;
                    })}
                    
                    {this.getImgCount() < 5 ?
                      <div className='imageBlock'>
                        <div className='imgWrapper'>
                          <div className='imgLiner'>
                            <Dropzone onDrop={acceptedFiles => this.onDropImage(acceptedFiles)}>
                              {({getRootProps, getInputProps}) => (
                                <section>
                                  <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div 
                                      className={this.state.imgDrag ? 'dropWrapper drag' : 'dropWrapper'}
                                      onDragEnter={this.dragEnterInput.bind(this)}
                                      onDragLeave={this.dragLeaveInput.bind(this)}>
                                      <div className={this.state.imgDrag ? 'dropPrompt drag' : 'dropPrompt'}>
                                        <div className='dropIcon'>
                                          {this.state.imgPending ? '...' : '+'}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </section>
                              )}
                            </Dropzone>
                          </div>
                        </div>
                        <div className='controlWrapper'>
                          <div className='controlLiner'>Upload</div>
                        </div>
                      </div> :
                      null
                    }
  
                  </div>
                </div>
              </div> :
              null
            }
            {!isLoggedIn() ?
              <div className='shareWrapper'>
                <div className='shareLabel'>Share with:</div>
                <div className='shareIconRow'>
                  {this.props.users.customerCard ?
                    <a href={'mailto:' + this.props.users.customerCard.email + '?subject=' + encodeURIComponent('My diamond collection') + '&body=' + encodeURIComponent('Check out the diamond collection I have shared! ' + base_url + '/shared-collection/' + this.props.users.customerCard.lookup_key)}>
                      <div className='shareIcon' onClick={this.addIndividualDiamondToCard.bind(this)}>
                        <img src='/img/icons/share/email.svg' />
                      </div>
                    </a> : 
                    <div className='shareIcon' onClick={() => this.queueShare(this.state.watch)}>
                      <img src='/img/icons/share/email.svg' />
                    </div>
                  }
                  {this.props.users.customerCard ?
                    <a href={'https://www.facebook.com/sharer/sharer.php?u=' + base_url + '/shared-collection/' + this.props.users.customerCard.lookup_key} target="_blank" style={{display: 'none'}}>
                      <div className='shareIcon' onClick={this.addIndividualDiamondToCard.bind(this)}>
                        <img src='/img/icons/share/facebook.svg' />
                      </div>
                    </a> : 
                    <div className='shareIcon' onClick={() => this.queueShare(this.state.watch)} style={{display: 'none'}}>
                      <img src='/img/icons/share/facebook.svg' />
                    </div>
                  }
                  {this.props.users.customerCard ?
                    <a href={'https://api.whatsapp.com/send?text=' + encodeURIComponent('Check out the diamond collection I have shared! ' + base_url + '/shared-collection/' + this.props.users.customerCard.lookup_key)} target="_blank">
                      <div className='shareIcon' onClick={this.addIndividualDiamondToCard.bind(this)}>
                        <img src='/img/icons/share/whatsapp.svg' />
                      </div>
                    </a> : 
                    <div className='shareIcon' onClick={() => this.queueShare(this.state.watch)}>
                      <img src='/img/icons/share/whatsapp.svg' />
                    </div>
                  }
                  {this.props.users.customerCard ?
                    <a href={'sms:?&body=' + encodeURIComponent('Check out the diamond collection I have shared! ' + base_url + '/shared-collection/' + this.props.users.customerCard.lookup_key)}>
                      <div className='shareIcon' onClick={this.addIndividualDiamondToCard.bind(this)}>
                        <img src='/img/icons/share/text.svg' />
                      </div>
                    </a> : 
                    <div className='shareIcon' onClick={() => this.queueShare(this.state.watch)}>
                      <img src='/img/icons/share/text.svg' />
                    </div>
                  }
                </div>
              </div> :
              null
            }
            <div className='locationRowWrapper'>
              <div className='locationWrapper' style={{ display: 'none' }}>
                <div className='locationIcon'>
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className='locationValue'>{formatLocation(this.state.watch)}</div>
              </div>
            </div>
            <div className='detailWrapper'>
              <div className='detailBlock'>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Price:</div>
                    <div className='detailValue'>{formatPrice(this.state.watch)}</div>
                  </div>
                  <div className='detailEntry' style={{ display: 'none' }}>
                    <div className='detailLabel'>Carat:</div>
                    <div className='detailValue'>{this.state.watch.sku}</div>
                  </div>

                  
                </div>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Group:</div>
                    <div className='detailValue'>{this.state.watch.group}</div>
                  </div>
                  <div className='detailEntry' style={{ display: 'none' }}>
                    <div className='detailLabel'>Clarity:</div>
                    <div className='detailValue'>{this.state.watch.sku}</div>
                  </div>
                </div>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>SKU:</div>
                    <div className='detailValue'>{this.state.watch.sku}</div>
                  </div>
                  <div className='detailEntry' style={{ display: 'none' }}>
                    <div className='detailLabel'>Polish:</div>
                    <div className='detailValue'>{this.state.watch.sku}</div>
                  </div>
                </div>
              </div>
              <div className='detailBlock'>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Movement:</div>
                    <div className='detailValue'>{this.state.watch.movement ? this.state.watch.movement : ''}</div>
                  </div>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Case Material:</div>
                    <div className='detailValue'>{this.state.watch.case_material ? this.state.watch.case_material : ''}</div>
                  </div>
                </div>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Crystal Type:</div>
                    <div className='detailValue'>{this.state.watch.crystal ? this.state.watch.crystal : ''}</div>
                  </div>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Case Size:</div>
                    <div className='detailValue'>{parseFloat(this.state.watch.case_size) ? `${this.state.watch.case_size} mm` : ''}</div>
                  </div>
                </div>
                <div className='detailColumn'>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Dial Color:</div>
                    <div className='detailValue'>{this.state.watch.dial_color ? this.state.watch.dial_color : ''}</div>
                  </div>
                  <div className='detailEntry'>
                    <div className='detailLabel'>Band Material:</div>
                    <div className='detailValue'>{this.state.watch.band_material ? this.state.watch.band_material : ''}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='manageDiamondActions' style={{ display: 'none' }}>
              {isLoggedIn() ?
                <div>
                  <button 
                    className={'transferButton manageButton secondaryButton'} 
                    disabled={true} 
                    onClick={this.openTransferModal.bind(this)}>Transfer</button>
                </div> :
                null
              }
            </div>
            <div className='backToResultsWrapper'>
              <div className={'backToResultsButton bottomAction alwaysBottom'} onClick={this.backButtonNav.bind(this)}>Back to Results</div>
              <div className='bottomActionSpacer alwaysBottom'></div>
            </div>
          </div>
        </div>
      }


      <RhinoModal
        open={this.state.transferModalOpen}>
        <div className='transferModal'>
          <div className='closeModal' onClick={this.closeTransferModal.bind(this)}>&times;</div>
          <div className='transferModalTitle'>Submit Transfer Request</div>
          <div className='transferModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferName.bind(this)}
              value={this.state.transferName}
              placeholder='Customer Name' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              className={this.state.transferApptDateError ? 'error' : ''}
              onChange={this.changeTransferApptDate.bind(this)}
              value={this.state.transferApptDate}
              placeholder='Appointment Date*' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferApptTime.bind(this)}
              value={this.state.transferApptTime}
              placeholder='Appointment Time' />
          </div>
          <div className='transferModalInput'>
            <input
              type='text'
              onChange={this.changeTransferBudget.bind(this)}
              value={this.state.transferBudget}
              placeholder='Estimated Budget' />
          </div>
          <div className='transferModalInput'>
            <textarea
              type='text' 
              onChange={this.changeTransferMessage.bind(this)} 
              value={this.state.transferMessage}
              placeholder='Include an optional message'></textarea>
          </div>
          <div className='transferModalButton'>
            <button className={'actionButton transferButton'} onClick={this.transferWatch.bind(this)}>Submit Request</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoModal
        open={this.state.shareModalOpen}>
        <div className='shareModal'>
          <div className='closeModal' onClick={this.closeShareModal.bind(this)}>&times;</div>
          <div className='shareModalTitle'>Who would you like to share with?</div>
          <div className='shareModalHr'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='shareModalButtons'>
            <button className={'actionButton shareButton'} onClick={this.openShareInternal.bind(this)}>Employees</button>
            <button className={'actionButton shareButton'} onClick={this.openShareExternal.bind(this)}>Customers</button>
          </div>
        </div>
      </RhinoModal>
      <RhinoConfirm
        confirmTitle='Delete?'
        confirmText='Are you sure you want to remove this image?'
        confirmMethod={this.removeImg.bind(this)}
        cancelMethod={this.imageDeleteConfirm.bind(this)}
        open={this.state.imageDeleteOpen} />
    </div>;
  }
}
export default SingleWatch;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    diamonds: state.diamonds,
    users: state.users,
  };
}

export const SingleWatchContainer = connect(
  mapStateToProps,
  allActionCreators
)(SingleWatch);